import Content from "../components/AMC/PageValidation/Content";
import i18n from "../resources/I18n";
import { INavigationParcours } from "../util/Navigation";

interface IPageValidationAMCProps {
  cookieParcoursAssurance: INavigationParcours;
  parcours: string;
}

function PageValidationAMC(props: Readonly<IPageValidationAMCProps>) {
  return (
    <div data-testid="page-amc" className="App">
      <output
        id="chargement-termine-amc"
        data-testid="chargement-termine-amc"
        className="dsd-sr-only"
        aria-live="polite"
      >
        {i18n.t("amc:sr-only-chargement-termine")}
      </output>

      <Content cookieParcoursAssurance={props.cookieParcoursAssurance} parcours={props.parcours}/>
    </div>
  );
}

export default PageValidationAMC;
